import type { AddendumFieldPolicy } from '../model/addendum-field-policy.model';

export const ADDENDUM_FIELD_POLICY: AddendumFieldPolicy = {
  aiFindings: 'disabled',
  comparison: 'editable',
  conditions: 'editable',
  consultNotes: 'editable',
  defaultQuestion: 'editable',
  degenerativeChange: 'editable',
  finalImpressions: 'disabled',
  // Only editable when addendumStatus is 'added'
  finding: 'editable',
  findingOutput: 'editable',
  followUp: 'disabled',
  incompleteScan: 'editable',
  keyImages: 'editable',
  normals: 'editable',
  patientContact: 'editable',
  qualityReview: 'editable',
  reasonForScan: 'disabled',
  technique: 'editable',
  urgencyCategory: 'editable',
} as const;
